import React from 'react';
import { Button } from "react-bootstrap";
import './FileUpload.scss';

export type UploadedWithNoErrorsProps = {
    onImportSubmit: any;
    fileName: string;
    recordsFound: number;
    onFileRemoved: any;
};

const UploadedWithNoErrors = (props: UploadedWithNoErrorsProps) => (
    <div className="container" style={{ width: "50%" }}>
        <div className="row" style={{ height: "450px" }}>
            <div className="col file-upload-container align-self-center" style={{ border: "1px solid #c1bbbb" }}>
                <div className="uploaded-no-errors-container">
                    <i className="fa fa-check uploaded-no-errors-check"></i>
                </div>
                <div className="uploaded-success-info uploaded-no-errors-container">
                    <span>File Uploaded with No Errors</span>
                </div>
                <div className="uploaded-no-errors-container">
                    <span style={{ color: "black" }}>
                        {props.fileName} {" "}
                        <button className="btn btn-link" onClick={props.onFileRemoved} style={{ fontSize: "12px" }}>REMOVE FILE</button>
                    </span>
                </div>
                <div className="uploaded-no-errors-container">{props.recordsFound} records found</div>
                <div className="uploaded-no-errors-container">
                    <Button onClick={props.onImportSubmit}>
                        IMPORT RECORDS
                            </Button>
                </div>
            </div>
        </div>
    </div>
);

export default UploadedWithNoErrors;
